import { frontendURL } from '../../../../helper/URLHelper';
const SettingsWrapper = () => import('../SettingsWrapper.vue');
const Index = () => import('./Index.vue');
const AddCredits = () => import('./AddCredits.vue');
const Subscribe = () => import('./Subscribe.vue');
const Checkout = () => import('./Checkout.vue');
const TapCallback = () => import('./TapCallback.vue');
const WalletCallback = () => import('./WalletCallback.vue');
const DebitRecipients = () => import('./DebitRecipients.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/billing'),
      meta: {
        permissions: ['administrator'],
      },
      component: SettingsWrapper,
      props: {},
      children: [
        {
          path: '',
          name: 'billing_settings_index',
          component: Index,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'add-credits',
          name: 'settings_billing_add_credits',
          component: AddCredits,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'subscribe',
          name: 'settings_billing_subscribe',
          component: Subscribe,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'checkout',
          name: 'settings_billing_checkout',
          component: Checkout,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'tap/callback',
          name: 'settings_billing_tap_callback',
          component: TapCallback,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'tap/wallet-callback',
          name: 'settings_billing_wallet_callback',
          component: WalletCallback,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'debit-recipients',
          name: 'settings_billing_debit_recipients',
          component: DebitRecipients,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
